<template>
  <section class="prizes__carousel">
    <div class="prizes-carousel generic-carousel">
      <div class="item" v-for="prize in carouselVisitorPrizes" :key="prize.type" style="cursor: pointer">
        <img :src="prize.imgUrl" alt="">
<!--        <span>{{ prize.headline }}</span>-->
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import 'owl.carousel';

export default {
  name: 'visitorCarousel',
  mounted() {
    this.$nextTick(() => {
      /*eslint-disable */
      // default home page carousel
      $('.prizes-carousel').owlCarousel({
        loop: true,
        responsiveClass: true,
        dots: this.carouselVisitorPrizes.length > 1,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        navContainer: '.carousel__nav',
        dotsContainer: '.prizes__carousel__dots',
        navText: ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
        responsive: {
          0: {
            items: 1,
            nav: true
          }
        }
      });
    });
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapState('profile', [
      'carouselVisitorPrizes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/VisitorCarousel.vue